const sdLocalizationModule = angular.module("sdLocalization", []);

export default sdLocalizationModule;
